module.exports = __webpack_public_path__ + "img/834741_4C281D_BE8F8C_AE6A65-256px.dcb68020.png";